export default __webpack_public_path__ + "static/media/Precise-Logo.7371858b.png";